import { render, staticRenderFns } from "./RegraSegmento.vue?vue&type=template&id=37f06f54&scoped=true"
import script from "./RegraSegmento.vue?vue&type=script&lang=js"
export * from "./RegraSegmento.vue?vue&type=script&lang=js"
import style0 from "./RegraSegmento.vue?vue&type=style&index=0&id=37f06f54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f06f54",
  null
  
)

export default component.exports